<template>
	<div class="" :class="{'modal-backdrop fade': true, 'show': isVisible}"></div>
</template>

<script>
    export default {
        name: "ModalBackDropComponent",
        computed: {
            isVisible() {
                return this.$store.getters.isVisibleModal;
            }
        }
    };
</script>